import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getSearchParams } from '@tmap-web-lib/utils'
import { PageIdSearchParams } from '@/providers'
import qs from 'qs'
import { RoutePath } from '@/routes/paths'

/**
 * 404 발생 시 홈으로 보내고 CheckPageId 컴포넌트에서 extra로 파단하여 리디랙션 처리한다.
 * CheckPageId에서 pageid가 없는 경우 홈으로 리디랙션 한다.
 */
function Fallback404() {
  const navigate = useNavigate()

  useEffect(() => {
    const searchParams = getSearchParams<PageIdSearchParams>()

    navigate({
      pathname: RoutePath.Home,
      search: qs.stringify({ ...searchParams }),
    }, { replace: true })
  }, [navigate])

  return null
}

export { Fallback404 }
